import React, { useRef, useEffect, useState, useMemo } from 'react';
import ReactDOM from 'react-dom';
import './SingleArticle.css';
import ArticleBox from './components/Article';
// import randomizeData from '../../public Func/RandomData';
import axios from '../../public Func/axiosAuth';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faPen } from '@fortawesome/free-solid-svg-icons';
import { useParams, useSearchParams, useNavigate } from 'react-router-dom';
import formatDate from '../../public Func/DateFix';
import ArticleCommentBox from './components/ArticleComment';
import Markdown from '../../components/Markdown/Markdown';
import ArticleEditModal from './components/ArticleEditModal';

// Matches the server-side cap on the comment `limit`.
const COMMENT_LIMIT = 100;


function SingleArticlesPage() {
    const {articleID} = useParams()
    const navigate = useNavigate()

    const [article,setArticleList] = useState({})
    const [isAtEnd, setIsAtEnd] = useState(true);
    const [loadingStatus,setLoadingStatus] = useState('shown')
    const divRef = useRef(null);
    const [RateColor,setRateColor] = useState("rateGreen")
    const [UserImage,setUserImage] = useState("")
    const [imageList,setImageList] = useState([])

    // Get current logged-in supervisor/admin ID
    const currentUserId = localStorage.getItem('id') || localStorage.getItem('supervisorID') || localStorage.getItem('supervisor_id');
    const currentRole = localStorage.getItem('role');
    const isCurrentUserSupervisor = currentRole === 'supervisor' || currentRole === 'Supervisor' || currentRole === 'super';
    
    // Check if this is supervisor's own article (recalculated when article changes)
    // Simplified: if user is supervisor and article is by supervisor, show delete button
    const isOwnArticle = useMemo(() => {
        if (!article || !article.id) return false;
        // Show delete if user is supervisor and article is by supervisor
        if (isCurrentUserSupervisor && article.isSupervisor) {
            return true;
        }
        return false;
    }, [article, isCurrentUserSupervisor]);

    // Comments
    // Comments. The whole thread is fetched in one request and scrolls inside the
    // article, instead of paging two-at-a-time behind a "see more" click.
    const [commentList,setCommentList] = useState([])
    const [loadingComments,setLoadingComments] = useState(false)
    const [commentsExpanded,setCommentsExpanded] = useState(false)


    //// Report Part
    const [somthingElse,setsomthingElse] = useState(false)
    const [showReportModal, setShowReportModal] = useState(false)
    const [selectedReason, setSelectedReason] = useState(null)
    const [showErrorMessage,setshowErrorMessage] = useState(null)

    // Delete Article Part
    const [showDeleteModal, setShowDeleteModal] = useState(false)
    const [isDeleting, setIsDeleting] = useState(false)

    // Edit Article Part
    const [showEditModal, setShowEditModal] = useState(false)

    function showEditForm(){
        setShowEditModal(true)
    }

    function hideEditModal(){
        setShowEditModal(false)
    }

    function handleArticleSaved(updatedArticle){
        const updated = {...article,
            title: updatedArticle.title,
            mainText: updatedArticle.mainText,
            category: updatedArticle.category,
            categoryID: updatedArticle.categoryID,
            coverImage: updatedArticle.coverImage,
            date: updatedArticle.date,
            edited: true,
        }
        setArticleList(updated)
        setShowEditModal(false)
    }

    function showDeleteConfirm(){
        setShowDeleteModal(true)
    }

    function hideDeleteModal(){
        setShowDeleteModal(false)
    }

    async function deleteArticle(){
        setIsDeleting(true)
        try{
            const res = await axios.delete(process.env.REACT_APP_BACKEND_URL + '/admin/article', {
                data: { articleID: article.id }
            })
            
            if(res.status === 200 && (res.data === 'Done' || res.data?.message === 'Done' || res.data?.done)){
                hideDeleteModal()
                // Redirect to articles page after successful deletion
                navigate('/articles')
            } else {
                setshowErrorMessage('Failed to delete article. Please try again.')
            }
        } catch(err){
            console.error('Error deleting article:', err)
            setshowErrorMessage(err.response?.data || 'Failed to delete article. Please try again.')
        } finally {
            setIsDeleting(false)
        }
    }
    
    // Hiding the Popup Window
    function hideReportForm(){
        setShowReportModal(false)
        setTimeout(() => {
            setsomthingElse(false)
            setshowErrorMessage(null)
            setSelectedReason(null)
        }, 300)
    }

    // Showing the Popup Window
    function ShowPopupReportForm(){
        setShowReportModal(true)
        setsomthingElse(false)
        setshowErrorMessage(null)
        setSelectedReason(null)
    }

    // Choose a Reason
    function SelectReportReason(event){
        const reason = event.currentTarget.innerHTML
        setSelectedReason(reason)
        if(reason === 'Somthing Else'){
            setsomthingElse(true)
        }else{
            setsomthingElse(false)
        }
    }   
    async function submitReportForm(event){
        var reason = ''
        // Data Reading and Validation
        if (selectedReason === null){
            setshowErrorMessage('You Have To Choose a Reason')
            return;
        }
        reason = selectedReason
        if (selectedReason === 'Somthing Else'){
            const inputValue = event.currentTarget.parentElement.querySelector("input").value
            if (inputValue ==''){
                setshowErrorMessage('You Have To Write a Reason')
                return
            }
            reason = inputValue
        }
        setshowErrorMessage(null)
        try{
            hideReportForm()
            
            axios.delete(process.env.REACT_APP_BACKEND_URL+"/super/article",{data:{articleID:article.id,reason:reason}}).then((res)=>{
                window.location.href = '/articles';
            }).catch((err)=>{
                console.log("Error!!\n",err)
            })
        }catch(err){
            console.log("Error!!\n",err)
        }

    }
    // Sending To Get The Article
    useEffect(() => {
        const fetchData = async () => {
        try {
            const res = await axios.get(
            process.env.REACT_APP_BACKEND_URL +
                "/blog/article?" +
                `articleID=${articleID}`

            );
            setArticleList(res.data)
            
            // Validate For anonymous
            setUserImage(<img src={res.data.doctorProfileImage} alt={res.data.doctorName + " Profile Pic"}/>)
            
            // Uploaded Images
            const images = []
            for(var i of res.data.images){
                images.push(<img src={process.env.REACT_APP_BACKEND_URL+"/file/"+i.link} alt="Article content"/>)
            }
            setImageList(images)

            // AI Rating Colors
            if (Number(res.data.AI_saftyRate)<50){
                setRateColor("rateRed")
            }else if (Number(res.data.AI_saftyRate)<75){
                setRateColor("rateYellow")
            } else {
                setRateColor("rateGreen")
            }
            setLoadingStatus("disabled")

        } catch (err) {
            console.error("Error fetching article:", err);
        }
        };
    
        fetchData();
    
        // Cleanup function to handle potential cancellation or cleanup tasks
        return () => {};
    }, [articleID]);


    // Load the whole comment thread in one request. The endpoint orders by date DESC,
    // so the newest comment is first.
    async function loadComments(){
        setLoadingComments(true)
        try{
            const res  = await axios.get(process.env.REACT_APP_BACKEND_URL+"/blog/comment-list?limit="+COMMENT_LIMIT+"&articleID="+articleID)
            setCommentList(Array.isArray(res.data) ? res.data : [])
        }catch(err){
            console.log("Error loading comments!!")
            console.log(err)
            setCommentList([])
        }finally{
            setLoadingComments(false)
        }
    }

    // Load the thread the first time the article is rendered.
    useEffect(()=>{
        loadComments()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [articleID])
    useEffect(()=>{

    })
    return (
        <div className='single-article-page'>
            <div className='SingleArticleBox'>
                <div className='ArticleHeader'>
                    <div className='left'>
                        <span className='starRate' title={`${article.doctorName} Star Rating`}>
                            <FontAwesomeIcon icon="fa-solid fa-star" /> {article.doctorStarRate}
                        </span>
                        <span title={`The Number of Session ${article.doctorName} Had`}>
                            <FontAwesomeIcon icon="fa-solid fa-calendar-check" /> {article.doctorSessionNumber}
                        </span>
                        <span className={'aiRate ' + RateColor} title="AI Safety Rating">
                            <FontAwesomeIcon icon="fa-solid fa-robot" /> {article.AI_saftyRate}% - ({article.AI_saftyWord})
                        </span>
                    </div>
                    <div className='center'>
                        {UserImage}
                        <div className='AutherInfo'>
                            <p>{article.doctorName}</p>
                            <p>{article.doctorTitle}</p>
                            <p className='date'>{formatDate(article.date)}</p>
                        </div>
                    </div>
                    <div className='right'>
                        <div className='Tags'>
                            <span className='Community'>{article.category}</span>
                            <span className={'Edit' + (isDeleting ? ' disabled' : '')} onClick={showEditForm} style={{pointerEvents: isDeleting ? 'none' : 'auto'}}>
                                <FontAwesomeIcon icon={faPen} style={{ marginRight: '0.25rem' }} />
                                Edit
                            </span>
                            {/* Show Delete button for admin's own articles or supervisor's own articles only.
                                Admins may edit any article, but may only delete the ones they authored.
                                Check multiple conditions: isAdmin, adminEmail, isSupervisor flag, or supervisorID exists */}
                            {((article.isAdmin || article.adminEmail) ||
                              (isCurrentUserSupervisor && (article.isSupervisor || article.supervisorID))) && (
                                <span className={'Delete' + (isDeleting ? ' disabled' : '')} onClick={showDeleteConfirm} style={{pointerEvents: isDeleting ? 'none' : 'auto'}}>
                                    <FontAwesomeIcon icon={faTrash} style={{ marginRight: '0.25rem' }} />
                                    Delete
                                </span>
                            )}
                            {/* Show Report button only if it's not the supervisor's own article and not admin's article */}
                            {!(isCurrentUserSupervisor && (article.isSupervisor || article.supervisorID)) && !(article.isAdmin || article.adminEmail) && (
                            <span className='Report' onClick={ShowPopupReportForm}>Report</span>
                            )}
                        </div>
                    </div>
                </div>
                <div className='ArticleBody'>
                    {article.coverImage?<div className='CoverImage'>
                        <img src={article.coverImage} alt="Article Cover"/>
                    </div>:''}
                    <div className='ArticleText'>
                        <h1>{article.title}</h1>
                        <Markdown>{article.mainText}</Markdown>
                    </div>
                    <div className='ArticleImages'>
                        {imageList}
                    </div>
                </div>
                <div className='Reactions'>
                    <div className='left'>
                        <span title='How Many Times the Article Was Displayed on a Screen'>
                            <FontAwesomeIcon icon="fa-solid fa-eye" /> {article.views}
                        </span>
                    </div>
                    <div className='right'>
                        <span title='How Many People Reacted To This Article (Doctors and Patients)'>
                            <FontAwesomeIcon icon="fa-solid fa-heart" /> {Number(article.upVotes) || 0 + Number(article.DoctorUpVotes) || 0}
                        </span>
                        <span title='Total Comment Number'>
                            <FontAwesomeIcon icon="fa-solid fa-comment" /> {article.commentsNumber}
                        </span>
                    </div>
                </div>
                <div className='Comments'>
                    <div className={'CommentsBox'+(commentsExpanded?' expanded':'')}>
                        {commentList.length > 0 ? commentList.map((comment) => (
                            <ArticleCommentBox key={comment.id} commentData={comment}/>
                        )) : (
                            !loadingComments && <p className='NoComments'>No Comments on This Article</p>
                        )}
                    </div>
                    {loadingComments && <div className='CommentsButton disabled'>Loading Comments ...</div>}
                    {commentList.length > 6 && (
                        <div className='CommentsButton enabled' onClick={()=>setCommentsExpanded(!commentsExpanded)}>
                            {commentsExpanded ? 'Collapse comments' : 'Show all '+commentList.length+' comments'}
                        </div>
                    )}
                </div>
            </div>

            {showReportModal && ReactDOM.createPortal(
                <div className='ReportPopupWindow'>
                    <div className='backgroundBlock' onClick={hideReportForm}></div>
                    <div className='ReportForm'>
                        <h1 className='TitleReport'>Report</h1>
                        <h3 className='ForNextArticle'>The Article:</h3>
                        <p className='ReportMainArticleText'>{article.title}</p>
                        <div className='ReportTagOptions'>
                            <span className={'ReportTag' + (selectedReason === 'Spam' ? ' selected' : '')} onClick={SelectReportReason}>Spam</span>
                            <span className={'ReportTag' + (selectedReason === 'Nudity' ? ' selected' : '')} onClick={SelectReportReason}>Nudity</span>
                            <span className={'ReportTag' + (selectedReason === 'Scam' ? ' selected' : '')} onClick={SelectReportReason}>Scam</span>
                            <span className={'ReportTag' + (selectedReason === 'Illigal' ? ' selected' : '')} onClick={SelectReportReason}>Illigal</span>
                            <span className={'ReportTag' + (selectedReason === 'Sucide or Self-injury' ? ' selected' : '')} onClick={SelectReportReason}>Sucide or Self-injury</span>
                            <span className={'ReportTag' + (selectedReason === 'Violance' ? ' selected' : '')} onClick={SelectReportReason}>Violance</span>
                            <span className={'ReportTag' + (selectedReason === 'Hate Speech' ? ' selected' : '')} onClick={SelectReportReason}>Hate Speech</span>
                            <span className={'ReportTag' + (selectedReason === 'Somthing Else' ? ' selected' : '')} onClick={SelectReportReason}>Somthing Else</span>
                        </div>
                        <div className={'ReasonInputForm'+(somthingElse?" show":"")}>
                            <h2>Reason:</h2>
                            <p>Write a Simple Message For the Report Reason</p>
                            <input type='text' placeholder='Write the Message'/>
                        </div>
                        <button className='submutReportButton' onClick={submitReportForm}>Submit Report</button>
                        <p className={'ErrorMessage'+(showErrorMessage?" show":"")}>{showErrorMessage}</p>
                    </div>
                </div>,
                document.body
            )}

            {/* Delete Confirmation Modal */}
            {showDeleteModal && ReactDOM.createPortal(
                <div className='ReportPopupWindow'>
                    <div className='backgroundBlock' onClick={hideDeleteModal}></div>
                    <div className='ReportForm'>
                        <h1 className='TitleReport'>Delete Article</h1>
                        <h3 className='ForNextArticle'>Are you sure you want to delete this article?</h3>
                        <p className='ReportMainArticleText'>{article.title}</p>
                        <div style={{ display: 'flex', gap: '1rem', marginTop: '2rem' }}>
                            <button className='submutReportButton' onClick={hideDeleteModal} style={{ background: 'var(--bg-secondary)', color: 'var(--text-primary)', flex: 1 }}>
                                Cancel
                            </button>
                            <button className='submutReportButton' onClick={deleteArticle} disabled={isDeleting} style={{ background: 'var(--danger-500)', flex: 1 }}>
                                {isDeleting ? 'Deleting...' : 'Delete'}
                            </button>
                        </div>
                        {showErrorMessage && (
                            <p className={'ErrorMessage show'}>{showErrorMessage}</p>
                        )}
                    </div>
                </div>,
                document.body
            )}

            {/* Edit Article Modal */}
            {showEditModal && (
                <ArticleEditModal
                    article={article}
                    onClose={hideEditModal}
                    onSaved={handleArticleSaved}
                />
            )}

            
        </div>
    );
}

export default SingleArticlesPage;
